import type { SVGProps } from 'react';
const SvgFence = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fence_svg__a)">
      <path
        fill="currentColor"
        d="M21 12v-2h-2V7l-3-3-2 2-2-2-2 2-2-2-3 3v3H3v2h2v2H3v2h2v4h14v-4h2v-2h-2v-2h2Zm-5-5.17 1 1V10h-2V7.83l.41-.41.59-.59Zm-4 0 .59.59.41.41V10h-2V7.83l.41-.41.59-.59ZM11 14v-2h2v2h-2Zm2 2v2h-2v-2h2ZM7 7.83l1-1 .59.59.41.41V10H7V7.83ZM7 12h2v2H7v-2Zm0 4h2v2H7v-2Zm10 2h-2v-2h2v2Zm0-4h-2v-2h2v2Z"
      />
    </g>
    <defs>
      <clipPath id="fence_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFence;
